import { render } from "./StructuredNameField.vue?vue&type=template&id=4d925b1f"
import script from "./StructuredNameField.vue?vue&type=script&lang=ts"
export * from "./StructuredNameField.vue?vue&type=script&lang=ts"
script.render = render

export default script